export default __webpack_public_path__ + "static/media/ads-web-4.bb3e9493.gif";